exports.default = {
  'load_members_failed': '加载成员失败',
  'empty_members': '暂无成员',
  'no_data': '暂无数据',
  'retry': '重试',
  'select_member': '选择成员',
  'load_roles_failed': '加载角色失败',
  'load_leave_members_failed': '加载离职成员失败',
  'current_page_search': '筛选当前页成员',
  'selected_count': '已选 {count} 项',
  'basic_info': '基础信息',
  'team_avatar': '团队头像',
  'edit_avatar': '修改头像',
  'team_name': '团队名称',
  'edit_team_name': '编辑团队名称',
  'team_name_required': '请输入团队名称',
  'team_description': '团队介绍',
  'save': '保存',
  'save_success': '保存成功！',
  'payment_info': '付费信息',
  'team_benefits': '团队权益',
  'version_info': '版本信息',
  'team_id': '团队ID',
  'owner': '所有者',
  'member_seats': '成员数/席位数',
  'team_remaining_points': '团队剩余积分',
  'member_count': '{count} 位成员,已删除成员和待激活成员不占用名额',
  'creation_time': '创建时间',
  'creation_time_format': '{y}年{m}月{d}日',
  'more_operations': '更多操作',
  'join_approval': '加入审核',
  'join_approval_desc': '开启后，成员加入团队需要团队管理员或超管审核',
  'transfer_team': '移交团队',
  'transfer_team_desc': '每个团队只有1位所有者，移交后你将变为普通成员',
  'transfer': '移交',
  'dissolve_team': '解散团队',
  'dissolve_team_desc': '解散后，团队内所有内容都会被彻底删除不可恢复，请谨慎操作',
  'dissolve': '解散',
  'crop_image': '剪切图片',
  'crop_image_question': '是否需要剪切图片？',
  'crop': '剪切',
  'upload_without_crop': '不剪切直接上传',
  'upload_image': '上传图片',
  'cancel': '取 消',
  'confirm': '确 定',
  'team_transfer': '团队转移',
  'user': '用户',
  'phone': '手机',
  'prompt': '提示',
  'email': '邮箱',
  'join_time': '加入时间',
  'operation': '操作',
  'transfer_btn': '转移',
  'image_type_error': '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
  'dissolve_team_prompt': '一旦你解散了团队，团队内所有智能体、项目文档、以及部门成员都将会被永久删除。这是一个不可恢复的操作，请谨慎对待！',
  'dissolve_team_title': '解散团队',
  'dissolve_team_input_placeholder': '请输入"DELETE"以确认',
  'dissolve_team_input_error': '请输入"DELETE"以确认',
  'transfer_team_confirm': '转移团队后您将成为团队普通成员！确定转移？',
  'transfer_team_confirm_title': '提示',
  'member': '成员',
  'department': '部门',
  'leave_member': '离职成员',
  'waiting_approval': '等待审批',
  'already_joined': '已加入',
  'add_sub_department': '添加子部门',
  'edit': '编辑',
  'move_up': '上移',
  'move_down': '下移',
  'delete': '删除',
  'search_name_phone_email': '姓名、手机、邮箱',
  'create_department': '新建部门',
  'mark_as_leaving': '操作离职',
  'change_department': '变更部门',
  'invite_members': '邀请成员',
  'name': '姓名',
  'edit_department': '编辑部门',
  'parent_department': '上级部门',
  'department_name': '部门名称',
  'department_name_required': '请输入部门名称',
  'get_department_list_failed': '获取部门列表失败',
  'add_department_failed': '添加部门失败',
  'edit_department_failed': '修改部门失败',
  'department_setting': '变更部门',
  'team_invitation': '团队邀请',
  'confirm_remove_member': '确定将该成员移除？',
  'tips': '提示',
  'executing': '执行中...',
  'operation_success': '操作成功！',
  'select_departments_to_change': '请先勾选要变更的成员',
  'protected_member_cannot_leave': '所有者和当前用户不能操作离职',
  'contains_protected_member': '所选成员包含所有者或当前用户，不能操作离职',
  'select_members_to_leave': '请先勾选要离职的成员',
  'select_members_to_operate': '请先勾选要操作的成员',
  'restore': '恢复',
  'clear': '清空',
  'previous_department': '离职前所属部门',
  'days_since_leaving': '离职天数',
  'leaving_date': '离职日期',
  'confirm_restore': '确定恢复成员?',
  'confirm_delete': '确定删除?',
  'confirm_clear': '确定清空?',
  'select_members_first': '请先勾选要操作的数据',
  'confirm_restore_member': '确定恢复成员?',
  'pass': '通过',
  'reject': '拒绝',
  'confirm_approve': '确定同意加入企业？',
  'confirm_reject': '确定拒绝加入企业？',
  'enter_department_name': '请输入部门名称',
  'batch_delete': '批量删除',
  'batch_edit': '批量编辑',
  'department_members': '部门人数',
  'department_member_count': '部门成员数',
  'department_manager': '负责人',
  'confirm_delete_department': '确定删除部门？',
  'already_highest_level': '已是最高一级了',
  'already_the_top_level': '已是最高一级了',
  'leave_date': '离职日期',
  'department_has_members': '部门或子部门中存在成员，无法删除',
  'already_top_level': '已是最高一级了',
  'select_departments_first': '请先勾选要删除的部门',
  'delete_child_first': '请先删除所有子部门再进行删除部门操作。',
  'select_departments_to_edit': '请先勾选要编辑的部门',
  'roles': '角色',
  'member_roles': '成员角色',
  'role_management': '角色管理',
  'role_authorization': '角色功能授权',
  'authorize_role': '功能授权',
  'no_authorization_items': '暂无可授权的团队管理功能',
  'create_role': '新建角色',
  'edit_role': '编辑角色',
  'role_name': '角色名称',
  'role_name_required': '请输入角色名称',
  'confirm_delete_role': '确定删除该角色？',
  'member_roles_and_limits': '成员角色与额度',
  'limit_management': '限额管理',
  'limit_management_desc': '为团队成员设置积分使用限额',
  'limit_status': '限额状态',
  'limit_enabled': '已启用',
  'limit_disabled': '不限额',
  'authorized_limit': '授权额度',
  'remaining_limit': '剩余额度',
  'assign_roles': '分配角色',
  'member_limit': '成员额度',
  'set_member_limit': '设置额度',
  'unlimited': '不限额',
  'enable_member_limit': '启用成员积分限额',
  'limit_adjustment': '本次额度调整',
  'current_authorized': '当前累计授权',
  'after_adjustment': '调整后累计授权',
  'adjust_member_limit': '调整额度',
  'limit_adjustment_description': '选择操作模式并输入积分数量',
  'limit_adjustment_mode': '模式',
  'limit_adjustment_add': '添加',
  'limit_adjustment_reduce': '减少',
  'limit_adjustment_points': '数量（积分）',
  'used_points': '已使用积分',
  'remaining_after_adjustment': '调整后剩余额度',
  'limit_reduction_max': '最多可减少 {max} 积分，仅可减少未使用额度',
  'invalid_points_amount': '请输入有效的非负整数积分',
  'remaining_limit_nonnegative': '调整后剩余额度不能小于 0，请增加额度后再确认',
  'enable_limit_base_hint': '开启限额时，以已使用积分作为授权基准，新增积分即为可用额度',
  'consumption_records': '消费记录',
  'points_ledger_desc': '查看当前团队下的积分获取、消费、过期和调整记录',
  'points_event': '积分事件',
  'occurred_at': '发生时间',
  'points_change': '积分变化',
  'points_balance': '剩余积分',
  'points_earned': '获取积分',
  'points_expired': '积分过期',
  'points_adjusted': '积分调整',
  'points_consumption': '积分消费',
  'agent_task': 'Agent任务',
  'expand_details': '展开明细',
  'collapse_details': '收起明细',
  'no_points_records': '暂无积分流水记录',
  'load_points_records_failed': '加载积分流水失败',
  'all_team_records': '全团队记录',
  'my_team_records': '我的记录',
  'unknown_member': '未知成员'
}
